<template>
  <ion-page>
    <master-layout pageTitle="پروفایل">

      <AjaxForm route="user/changePassword">

        <Loading :is="!profileLoaded" v-if="!profileLoaded"></Loading>
        <div v-if="profileLoaded">
          <div v-if="user">
            <ion-img :src="auto_service.logo_pic" class="logo-pic"></ion-img>
            <ion-card>
              <ion-card-content>
                <div>
                  <i class="far icon fa-tools"></i>
                  اتوسرویس :
                  {{ auto_service.title }}
                </div>
              </ion-card-content>
            </ion-card>
            <ion-card>
              <ion-card-content>
                <div>
                  <i class="far icon fa-list-ol"></i>
                  شماره پروانه :
                  {{ auto_service.license_number }}
                </div>
              </ion-card-content>
            </ion-card>
            <ion-card>
              <ion-card-content>
                <div>
                  <i class="far icon fa-calendar-day"></i>
                  تاریخ پروانه :
                  {{ auto_service.license_date }}
                </div>
              </ion-card-content>
            </ion-card>
            <ion-card>
              <ion-card-content>
                <div>
                  <i class="far icon fa-map-marked"></i>
                  استان :
                  {{ auto_service.state.title }} ،
                  شهر :
                  {{ auto_service.city.title }} ،
                  {{ auto_service.address }}
                </div>
              </ion-card-content>
            </ion-card>
            <ion-card>
              <ion-card-content>
                <div>
                  <i class="far fa-oil-can icon"></i>
                  مقدار روغن سوخته موجود :
                  <span v-if="auto_service.used_oil">
                        {{ auto_service.used_oil }}
                      </span>
                  <span v-else>0</span>
                  لیتر
                </div>
              </ion-card-content>
            </ion-card>
            <ion-card>
              <ion-card-header>
                <ion-title>کیف پول</ion-title>
              </ion-card-header>
              <ion-card-content>
                <div>
                  موجودی کیف پول شما :
                  <money :number="auto_service.balance"></money>
                  تومان
                </div>
                <div >
                  شارژ کیف پول :
                  <input v-model="charge_amount" type="tel" placeholder="مبلغ شارژ کیف پول(تومان)" class="form-control">
                  <ion-button @click="chargeWallet" color="tertiary" expand="full">شارژ</ion-button>
                </div>
              </ion-card-content>
            </ion-card>
          </div>
          <div v-if="error" class="alert alert-danger">
            {{ error }}
          </div>
        </div>

      </AjaxForm>
    </master-layout>
  </ion-page>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {IonPage,IonCardHeader,IonCard,IonCardContent} from '@ionic/vue';
import AjaxForm from "@/components/AjaxForm";
import Money from "@/components/Money";
import {showSystemNoti} from "@/shared/helper"
import {openWebpage} from '@/shared/helper';
import Loading from "@/components/Loading";

// import {getFormData} from '@/shared/helper'

export default {
  name: "AddWarehouse",
  components: {
    Loading,
    Money,
    AjaxForm,IonPage,IonCardHeader,IonCard,IonCardContent
  },
  data()
  {
    return {
      user: null,
      auto_service: null,
      profileLoaded: false,
      currentPlanStatus: null,
      currentPlanStatusText: '',
      charge_amount : ''
    }
  },
  async mounted()
  {

  },
  async created()
  {
    const result = await this.getProfileInfo();
    if (result)
    {
      if (result.ok)
      {
        this.profileLoaded = true;
        this.user = result.user;
        this.auto_service = result.auto_service;
      }
      else
      {
        this.profileLoaded = true;
        this.error = result.error
      }
    }
    else
    {
      this.profileLoaded = true;
      this.error = 'خطا در برقراری ارتباط با سرور'
    }
  },
  methods: {
    ...mapActions("customer", {
      getProfileInfo: 'getProfileInfo'
    }),
    chargeWallet()
    {
      const auto_service_id = this.auto_service._id;
      const charge_amount = parseInt(this.charge_amount);
      if (isNaN(charge_amount))
        return showSystemNoti('danger','مقدار باید عدد وارد شود.');
      if (charge_amount < 1000)
        return showSystemNoti('danger','حداقل میزان شارژ 1000 تومان می باشد');
      const url = process.env.VUE_APP_API_URL+'/AutoService/ChargeWallet/'+auto_service_id+'/'+charge_amount;
      openWebpage(url);
    }
  },
  computed: {
    ...mapGetters('auth', {
      currentUser: "getUserInfo"
    }),
  }
}

</script>

<style scoped>
.logo-pic {
  width: 200px;
  margin: 10px auto;
  box-shadow: -3px 3px 5px #00000078;
}

.icon {
  width: 30px;
  display: inline-block;
  text-align: center;
}
</style>